import classNames from "classnames";
import { FC, ReactNode } from "react";

type Props = {
  readonly children: ReactNode;
  readonly className?: string;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export const Container: FC<Props> = ({ children, className }) => {
  return (
    <div className={classNames("max-width-container", className)}>
      {children}
    </div>
  );
};
